<template>
  <div class="flex w-full">
    <a :href="relativeUrl" class="flex gap-3 w-full p-3 rounded-md bg-primary border border-primary shadow-primary hover:no-underline hover:border-brand-saturated hover:shadow-hover-card  focus:border-brand-saturated focus:shadow-hover-card" tabindex="0">
      <div class="flex p-2 rounded bg-secondary items-center h-fit">
        <svg v-if="item.content_type === 'how_to'" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 9.9V8.2C14.55 7.96667 15.1125 7.79167 15.6875 7.675C16.2625 7.55833 16.8667 7.5 17.5 7.5C17.9333 7.5 18.3583 7.53333 18.775 7.6C19.1917 7.66667 19.6 7.75 20 7.85V9.45C19.6 9.3 19.1958 9.1875 18.7875 9.1125C18.3792 9.0375 17.95 9 17.5 9C16.8667 9 16.2583 9.07917 15.675 9.2375C15.0917 9.39583 14.5333 9.61667 14 9.9ZM14 15.4V13.7C14.55 13.4667 15.1125 13.2917 15.6875 13.175C16.2625 13.0583 16.8667 13 17.5 13C17.9333 13 18.3583 13.0333 18.775 13.1C19.1917 13.1667 19.6 13.25 20 13.35V14.95C19.6 14.8 19.1958 14.6875 18.7875 14.6125C18.3792 14.5375 17.95 14.5 17.5 14.5C16.8667 14.5 16.2583 14.575 15.675 14.725C15.0917 14.875 14.5333 15.1 14 15.4ZM14 12.65V10.95C14.55 10.7167 15.1125 10.5417 15.6875 10.425C16.2625 10.3083 16.8667 10.25 17.5 10.25C17.9333 10.25 18.3583 10.2833 18.775 10.35C19.1917 10.4167 19.6 10.5 20 10.6V12.2C19.6 12.05 19.1958 11.9375 18.7875 11.8625C18.3792 11.7875 17.95 11.75 17.5 11.75C16.8667 11.75 16.2583 11.8292 15.675 11.9875C15.0917 12.1458 14.5333 12.3667 14 12.65ZM6.5 16C7.28333 16 8.04583 16.0875 8.7875 16.2625C9.52917 16.4375 10.2667 16.7 11 17.05V7.2C10.3167 6.8 9.59167 6.5 8.825 6.3C8.05833 6.1 7.28333 6 6.5 6C5.9 6 5.30417 6.05833 4.7125 6.175C4.12083 6.29167 3.55 6.46667 3 6.7V16.6C3.58333 16.4 4.1625 16.25 4.7375 16.15C5.3125 16.05 5.9 16 6.5 16ZM13 17.05C13.7333 16.7 14.4708 16.4375 15.2125 16.2625C15.9542 16.0875 16.7167 16 17.5 16C18.1 16 18.6875 16.05 19.2625 16.15C19.8375 16.25 20.4167 16.4 21 16.6V6.7C20.45 6.46667 19.8792 6.29167 19.2875 6.175C18.6958 6.05833 18.1 6 17.5 6C16.7167 6 15.9417 6.1 15.175 6.3C14.4083 6.5 13.6833 6.8 13 7.2V17.05ZM12 20C11.2 19.3667 10.3333 18.875 9.4 18.525C8.46667 18.175 7.5 18 6.5 18C5.8 18 5.1125 18.0917 4.4375 18.275C3.7625 18.4583 3.11667 18.7167 2.5 19.05C2.15 19.2333 1.8125 19.225 1.4875 19.025C1.1625 18.825 1 18.5333 1 18.15V6.1C1 5.91667 1.04583 5.74167 1.1375 5.575C1.22917 5.40833 1.36667 5.28333 1.55 5.2C2.31667 4.8 3.11667 4.5 3.95 4.3C4.78333 4.1 5.63333 4 6.5 4C7.46667 4 8.4125 4.125 9.3375 4.375C10.2625 4.625 11.15 5 12 5.5C12.85 5 13.7375 4.625 14.6625 4.375C15.5875 4.125 16.5333 4 17.5 4C18.3667 4 19.2167 4.1 20.05 4.3C20.8833 4.5 21.6833 4.8 22.45 5.2C22.6333 5.28333 22.7708 5.40833 22.8625 5.575C22.9542 5.74167 23 5.91667 23 6.1V18.15C23 18.5333 22.8375 18.825 22.5125 19.025C22.1875 19.225 21.85 19.2333 21.5 19.05C20.8833 18.7167 20.2375 18.4583 19.5625 18.275C18.8875 18.0917 18.2 18 17.5 18C16.5 18 15.5333 18.175 14.6 18.525C13.6667 18.875 12.8 19.3667 12 20Z" fill="rgb(var(--color-text-terciary))"/>
        </svg>

        <svg v-else-if="item.content_type === 'plugin' || item.content_type === 'plugin_example'" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.5 19H12.5V17.15L16 13.65V9H8V13.65L11.5 17.15V19ZM9.5 21V18L6 14.5V9C6 8.45 6.19583 7.97917 6.5875 7.5875C6.97917 7.19583 7.45 7 8 7H9L8 8V3H10V7H14V3H16V8L15 7H16C16.55 7 17.0208 7.19583 17.4125 7.5875C17.8042 7.97917 18 8.45 18 9V14.5L14.5 18V21H9.5Z" fill="rgb(var(--color-text-terciary))"/>
        </svg>

        <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 18H16V16H8V18ZM8 14H16V12H8V14ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z" fill="rgb(var(--color-text-terciary))"/>
        </svg>
      </div>
      <div class="flex flex-col w-full gap-1">
        <div class="text-terciary text-xs">
          {{ breadcrumbs }}
        </div>
        <div class="text-primary font-bold text-sm">
          {{ heading }}
        </div>
        <div class="text-secondary text-xs line-clamp-1">
          <SearchResultSnippet v-if="highlighetContent" :item="item" attribute="content" />
          <span v-else>{{ item.content }}</span>
        </div>
        <div class="flex gap-3 pt-1 items-center">
          <div v-for="product in products" class="flex gap-1.5 items-center">
              <ProductIcon :name="product.value" :background="false" />
              <span class="text-secondary text-xs">{{ product.label }}</span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import SearchResultSnippet from './SearchResultSnippet.vue';
import ProductIcon from './ProductIcon.vue';

const availableProducts = window.searchFilters.products;

export default {
  props: {
    item: Object,
  },
  components: {
    SearchResultSnippet,
    ProductIcon
  },
  computed: {
    highlighetContent() {
      return this.item._highlightResult?.content?.matchLevel !== 'none';
    },
    heading() {
      if (this.item.content_type === 'plugin_example') {
        return this.item.title;
      }
      if (this.item.content_type === 'plugin') {
        if (this.item.products && (this.item.products.includes('mesh') || this.item.products.includes('event-gateway') || this.item.products === 'ai-gateway')) {
          return `${this.item.hierarchy.lvl1} Policy`;
        } else {
          return `${this.item.hierarchy.lvl1} Plugin`;
        }
      }
      const levels = Object.entries(this.item.hierarchy)
        .filter(([key, value]) => key !== 'lvl0' && value !== null);

      if (levels.length > 0) {
        return levels[levels.length - 1][1];
      }
      return ''; // Or handle the case where there are no levels
    },
    breadcrumbs() {
      const levels = Object.entries(this.item.hierarchy)
        .filter(([key, value]) => key !== 'lvl0' && value !== null)
        .map(([key, value]) => value);

      if (this.item.content_type === 'plugin') {
        if (this.item.products && (this.item.products.includes('mesh') || this.item.products.includes('event-gateway') || this.item.products === 'ai-gateway')) {
          levels.unshift('Policies')
        } else {
          levels.unshift('Plugins')
        }
      }
      if (this.item.content_type === 'how_to') {
        levels.unshift('How-to Guides')
      }
      if (levels.length > 1) {
        levels.pop();
      }
      return levels.join(' > ');
    },
    relativeUrl() {
      const urlObj = new URL(this.item.url);
      return `${urlObj.pathname}${urlObj.hash}`;
    },
    products() {
      return availableProducts.filter((p) => this.item.products.includes(p.value));
    }
  },
};
</script>
